import { styled, SvgIcon } from "@mui/material";

export default styled(SvgIcon)(({ theme }) => ({
  stroke: theme.palette.text.primary,
  fill: theme.palette.text.primary,
}));

const StyledSvgIconWithContrastStroke = styled(SvgIcon)(({ theme }) => ({
  stroke: theme.palette.getContrastText(theme.palette.text.primary),
  fill: theme.palette.text.primary,
}));

export { StyledSvgIconWithContrastStroke };
